import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import ImageModal from '@/components/Helper/ImageModal.vue';
import PdfModal from '@/components/Helper/PdfModal.vue';
import VideoModal from '@/components/Helper/VideoModal.vue';
import YoutubeVideoModal from '@/components/Helper/YoutubeVideoModal.vue';
import {
  download,
  getFileSrc,
} from '@/helpers';
import {
  useStore,
} from '@/store';
import type {
  IMediaModal,
} from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'MediaModal',
  setup(__props) {


const utilStore = useStore.util;

function downloadMedia({ title, link }: IMediaModal): void {
  utilStore.imageModal = undefined;
  utilStore.videoModal = undefined;
  utilStore.pdfModal = undefined;

  const fileExtension = link.split('.').pop();
  const filename = `${title}.${fileExtension}`;

  const url = getFileSrc(link);
  if (!filename || !url) {
    return;
  }

  download(url, filename);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(utilStore).videoModal)
      ? (_openBlock(), _createBlock(VideoModal, {
          key: 0,
          title: _unref(utilStore).videoModal.title,
          videoUrl: _unref(getFileSrc)(_unref(utilStore).videoModal.link),
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_unref(utilStore).videoModal = undefined))
        }, null, 8, ["title", "videoUrl"]))
      : _createCommentVNode("", true),
    (_unref(utilStore).youtubeVideoModal)
      ? (_openBlock(), _createBlock(YoutubeVideoModal, {
          key: 1,
          title: _unref(utilStore).youtubeVideoModal.title,
          videoUrl: _unref(utilStore).youtubeVideoModal.link,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(utilStore).youtubeVideoModal = undefined))
        }, null, 8, ["title", "videoUrl"]))
      : _createCommentVNode("", true),
    (_unref(utilStore).imageModal)
      ? (_openBlock(), _createBlock(ImageModal, {
          key: 2,
          isDownloadable: _unref(utilStore).imageModal.isDownloadable,
          title: _unref(utilStore).imageModal.title,
          imageUrl: _unref(getFileSrc)(_unref(utilStore).imageModal.link),
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(utilStore).imageModal = undefined)),
          onDownload: _cache[3] || (_cache[3] = ($event: any) => (downloadMedia(_unref(utilStore).imageModal)))
        }, null, 8, ["isDownloadable", "title", "imageUrl"]))
      : _createCommentVNode("", true),
    (_unref(utilStore).pdfModal)
      ? (_openBlock(), _createBlock(PdfModal, {
          key: 3,
          isDownloadable: _unref(utilStore).pdfModal.isDownloadable,
          title: _unref(utilStore).pdfModal.title,
          pdfUrl: _unref(getFileSrc)(_unref(utilStore).pdfModal.link),
          pdfClass: "h-[300px] bg-green-200 p-1 md:h-100 lg:h-120",
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_unref(utilStore).pdfModal = undefined)),
          onDownload: _cache[5] || (_cache[5] = ($event: any) => (downloadMedia(_unref(utilStore).pdfModal)))
        }, null, 8, ["isDownloadable", "title", "pdfUrl"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})